import { route as boardsRoute } from "@faire/web-api/routes/boards";
import { route as categoryRoute } from "@faire/web-api/routes/category/c1CategoryUrlId";
import { route as myBrandsRoute } from "@faire/web-api/routes/my-brands";
import { route as productRoute } from "@faire/web-api/routes/product/productToken";
import { route as homeRoute } from "@faire/web-api/routes/root";
import { route as searchRoute } from "@faire/web-api/routes/search";
import { getCurrentPath } from "@faire/web/common/Path";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";

const ELIGIBLE_PAGES = [
  homeRoute,
  searchRoute,
  categoryRoute,
  productRoute,
  boardsRoute,
  myBrandsRoute,
];

export const isPathEligibleForShopifyNudge = (pathName?: string) => {
  const currentPathName = pathName ?? getCurrentPath().pathname;

  return !!ELIGIBLE_PAGES.find((whitelistPage) =>
    pathMatchesRoute(currentPathName, whitelistPage)
  );
};
